import IconClose from "@/app/(site)/_components/Atoms/Icons/IconClose"
import ButtonPill from "@/app/(site)/_components/Molecules/ButtonPill"
import useScrollLock from "@/app/(site)/_utils/_hooks/useScrollLock"
import useEcommerceStore from "@/app/(site)/contexts/ecommerce/store"
import { SearchFilter } from "@/lib/depict-client/types/api/ProductListingRequestV3"
import { t } from "@/translations"
import React, { FC, useState } from "react"
import { FilterState } from "../../filterReducer"
import FilterItems from "./FilterItems"

type MobileFilterProps = {
    clearAllFilters: () => void
    filters: SearchFilter[]
    centraLangCode: string
    selectedFiltersOptions: FilterState
    nHits: number
    setFilter: (
        field: string,
        op: string,
        value: string | string[] | number | number[],
        e: React.MouseEvent<HTMLDivElement>
    ) => void
}

const MobileFilter: FC<MobileFilterProps> = ({
    clearAllFilters,
    filters,
    centraLangCode,
    selectedFiltersOptions,
    nHits,
    setFilter
}) => {
    const isMobileFilterOpen = useEcommerceStore(state => state.isMobileFilterOpen)
    const toggleFilterModal = useEcommerceStore(state => state.toggleFilterModal)
    const { allowScroll } = useScrollLock()

    const [activeAccordions, setActiveAccordions] = useState<boolean[]>(
        Array(filters.length).fill(true)
    )

    const handleToggleFilterModal = () => {
        toggleFilterModal(false)
        allowScroll()
    }

    const handleToggleAccordion = (index: number) => {
        setActiveAccordions(prevState => {
            const newState = [...prevState]
            newState[index] = !newState[index]
            return newState
        })
    }

    const totalSelectedFilters = selectedFiltersOptions.filters.reduce(
        (acc: number, option: { data: string[] }) =>
            acc + (option.data ? option.data.length : 0),
        0
    )

    return (
        <div
            className={`fixed left-0 top-0 z-50 h-[100vh] w-full bg-white transition-transform duration-300 ${
                isMobileFilterOpen ? "translate-x-0" : "-translate-x-full"
            } md:hidden`}
        >
            <div className="flex items-center justify-between p-16">
                <h3 className="font-trimLight text-32 font-300 uppercase leading-110 tracking-[-2.4px] md:text-48 md:tracking-[-1.3px]">
                    {t(centraLangCode, "Filter")}
                </h3>
                <div onClick={() => handleToggleFilterModal()} className="cursor-pointer">
                    <IconClose />
                </div>
            </div>
            <FilterItems
                handleToggleAccordion={handleToggleAccordion}
                activeAccordions={activeAccordions}
                filters={filters}
                selectedFiltersOptions={selectedFiltersOptions}
                setFilter={setFilter}
            />
            <div className="center fixed bottom-60 flex w-full gap-16 p-16">
                <ButtonPill
                    onClick={() => {
                        handleToggleFilterModal()
                        totalSelectedFilters > 0 && clearAllFilters()
                    }}
                    color="black"
                    size="medium"
                    variant="secondary"
                    fullWidth
                >
                    {t(centraLangCode, totalSelectedFilters > 1 ? "Clear" : "Cancel")}
                </ButtonPill>
                <ButtonPill
                    onClick={() => handleToggleFilterModal()}
                    color="black"
                    size="medium"
                    variant="primary"
                    fullWidth
                >
                    {t(centraLangCode, "show-products", { nHits: nHits })}
                </ButtonPill>
            </div>
        </div>
    )
}

export default MobileFilter
